import React from "react";
import { Button, ButtonGroup } from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import FieldFrame from "./FieldFrame";
import RiskReviewQuestionCard from "../RiskReviewQuestionCard";

const YesNoField = ({ field, control, disabled, error, required, index }) => (
  <Controller
    control={control}
    name={field.code}
    render={({ field: input }) =>
      field.inputType?.startsWith("QUESTION") ? (
        <RiskReviewQuestionCard
          field={field}
          value={input.value}
          onChange={input.onChange}
          disabled={disabled}
          error={error}
          index={index || 0}
        />
      ) : (
        <FieldFrame field={field} error={error} isRequired={required}>
          <ButtonGroup isAttached variant="outline" size="sm">
            <Button
              colorScheme={input.value === true ? "blue" : "gray"}
              variant={input.value === true ? "solid" : "outline"}
              isDisabled={disabled}
              onClick={() => input.onChange(true)}
            >
              Yes
            </Button>
            <Button
              colorScheme={input.value === false ? "blue" : "gray"}
              variant={input.value === false ? "solid" : "outline"}
              isDisabled={disabled}
              onClick={() => input.onChange(false)}
            >
              No
            </Button>
          </ButtonGroup>
        </FieldFrame>
      )
    }
  />
);

export default YesNoField;
